import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, 
    DialogTitle, FormControl, IconButton, MenuItem, Select, TextField } from '@material-ui/core';
import { CheckCircle, DeleteForever, Search } from '@material-ui/icons';
import React, { useState } from 'react';
import { useEffect } from 'react';
import DrawingEditor from 'tasks/components/detail/DrawingEditor';
import CardTaskSign from 'tasks/components/sign/CardTaskSign';
import findDetailTaskByReference from 'tasks/services/detail/findDetailTaskById';
import findClientByTask from 'tasks/services/sign/findClientByTask';
import findLastTasksUseCase from 'tasks/services/sign/findLastTasksUseCase';
import findTaskByReferenceUseCase from 'tasks/services/sign/findTaskByReferenceUseCase';
import savePDFSignUseCase from 'tasks/services/sign/savePDFSignUseCase';
import showPDFSignUseCase from 'tasks/services/sign/showPDFSignUseCase';
import updateTaskUseCase from 'tasks/services/updateTaskUseCase';

const STATE_LOADING = "STATE_LOADING"
const STATE_WITHOUT_SIGN = "STATE_WITHOUT_SIGN"
const STATE_WITH_PDF = "STATE_WITH_PDF"
const STATE_SIGNING = "STATE_SIGNING"
const STATE_SAVED = "STATE_SAVED"

const TaskSignContainer = () => {
    const [statePDF, setStatePDF] = useState(STATE_WITHOUT_SIGN)
    const [canvas, setCanvas] = React.useState(null);
    const [taskData, setTaskData] = useState("")
    const [typePDF, setTypePDF] = useState(0)

    const [data, setData] = useState([])
    const [clientData, setClientData] = useState({})
    const [detailData, setDetailData] = useState({})

    const [openSearch, setOpenSearch] = useState(false)
    const [referenceSearch, setRefeferenceSearch] = useState("")
    const [numTask, setNumTask] = useState(1);

    const loadTasks = () => {
        findLastTasksUseCase(data, setData)
    }

    useEffect(() => {
        loadTasks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleShowPDFByReference = async(type) => {
        const taskData = await findTaskByReferenceUseCase(referenceSearch)
        setOpenSearch(false)
        handleShowPDF(taskData, type)
    }

    const handleShowPDF = async (taskData, type) => {
        setTaskData(taskData)
        setTypePDF(type)
        setStatePDF(STATE_LOADING)

        const clientData = await findClientByTask(taskData.dni)
        const detailData = await findDetailTaskByReference(taskData.id)
        setClientData(clientData)
        setDetailData(detailData)

        await showPDFSignUseCase(taskData, clientData, detailData, type)
        setStatePDF(STATE_SIGNING)
    }

    const handleButton = async () => {
        if (statePDF === STATE_WITH_PDF) {
            setStatePDF(STATE_SIGNING)
        } else if (statePDF === STATE_SIGNING) {
            setStatePDF(STATE_LOADING)
            const url = await showPDFSignUseCase(taskData, clientData, detailData, typePDF, canvas.toDataURL('PNG'))
            await savePDFSignUseCase(taskData.id, url, typePDF, canvas.toDataURL('PNG'))
            
            if (typePDF === 1) {
                taskData.dateDocSign1 = new Date().getTime()
            } else {
                taskData.dateDocSign2 = new Date().getTime()
            }

            await updateTaskUseCase(taskData, taskData)
            setStatePDF(STATE_SAVED)
        } else if (statePDF === STATE_SAVED) {
            setStatePDF(STATE_WITHOUT_SIGN)
        }
    }

    const handleButtonCancel = () => {
        if (statePDF === STATE_SIGNING) {
            setStatePDF(STATE_WITH_PDF)
        } else {
            setStatePDF(STATE_WITHOUT_SIGN)
        }
    }

    const cleanCanvas = () => {
        canvas.clear()
    }

    const mapButtonText = {
        STATE_WITH_PDF: 'Firmar',
        STATE_SIGNING: 'Aceptar firma',
        STATE_SAVED: 'Terminar'
    }

    const mapButtonCancelText = {
        STATE_WITH_PDF: 'Cancelar',
        STATE_SIGNING: 'Leer PDF',
        STATE_SAVED: 'Cancelar'
    }


    return (
        <div style={{ backgroundColor: '#f5f5f5', position: 'fixed', height: '100%', width: '100%', top: 0, overflow: 'scroll' }}>
            <div style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: '0', left: '0',
                zIndex: '1200',
                border: 'none',
                display: statePDF !== STATE_WITHOUT_SIGN ? 'initial' : 'none'
            }}>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column'}}>
                    <iframe
                        id="main-iframe"
                        title="PDF"
                        src=""
                        type="application/pdf"
                        style={{
                            width: '100%',
                            flex: 1,
                            display: statePDF === STATE_WITH_PDF || statePDF === STATE_SIGNING ? 'initial' : 'none'
                        }}
                    />
                    { statePDF === STATE_SIGNING && 
                        <div style={{ position: 'relative', flex: 1, width: '100%', border: '1px solid', backgroundColor: 'lightblue', display: 'flex', flexDirection: 'column', alignItems: 'center', flexWrap: 'wrap' }}>
                            <IconButton onClick={cleanCanvas} style={{ position: 'absolute', top: '60px', right: '25px', zIndex: 999 }}>
                                <DeleteForever style={{ fontSize: '60px', color: 'red' }} />
                            </IconButton>
                            <span style={{ fontSize: 20, fontWeight: 'bold', height: '50px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                                PORFAVOR, FIRME SOBRE EL RECUADRO BLANCO SITUADO AQUI DEBAJO: 
                            </span>
                            <div style={{ flex: 1, backgroundColor: 'white', width: '70%', borderStyle: 'solid' }}>
                                <DrawingEditor setCanvas={setCanvas} />
                            </div>
                            <div style={{ height: '80px' }} />
                        </div> 
                    }
                    {statePDF === STATE_LOADING && 
                        <div 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 1,
                                flexDirection: 'column',
                                width: '100%', 
                                backgroundColor: 'lightgray'
                            }}
                        >
                            <CircularProgress style={{ height: '200px', width: '200px' }} />
                            <span style={{ fontSize: '30px', marginTop: '15px' }}>
                                Cargando...
                            </span>
                        </div>
                    }
                    {statePDF === STATE_SAVED && 
                        <div 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 1,
                                flexDirection: 'column',
                                width: '100%', 
                                backgroundColor: 'lightgray'
                            }}
                        >
                            <CheckCircle style={{ fontSize: 300, color: 'green' }}/>
                            <span style={{ fontSize: '30px', marginTop: '15px' }}>
                                Guardado!
                            </span>
                        </div>
                    }
                    <div style={{ height: '150px', display: 'flex' }}>
                        { statePDF !== STATE_SAVED && 
                            <Button variant="contained" color="secondary" 
                                style={{ flex: 1, fontSize: '30px' }} 
                                onClick={handleButtonCancel}>
                                { mapButtonCancelText[statePDF] }
                            </Button> 
                        }
                        { statePDF !== STATE_LOADING && 
                            <Button variant="contained" color="primary" 
                                style={{ flex: 1, fontSize: '30px' }} 
                                onClick={handleButton}>
                                { mapButtonText[statePDF] }
                            </Button> 
                        }
                    </div>
                </div>
            </div>
            <div style={{ 
                marginTop: '60px', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', width: '500px', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <Button variant="contained" color="primary" onClick={() => setOpenSearch(true) }>
                        <Search />
                    </Button>
                    <FormControl style={{ minWidth: '100px' }}>
                        <Select value={numTask} onChange={event => setNumTask(event.target.value)}>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                { 
                    data.slice(0, numTask).map(task =>
                        <div style={{ marginBottom: '10px' }}>
                            <CardTaskSign 
                                data={task}
                                clientData={clientData}
                                showSign1={() => handleShowPDF(task, 1)}
                                showSign2={() => handleShowPDF(task, 2)}
                            />
                        </div>
                    )
                }
            </div>
            <Dialog open={openSearch}>
                <DialogTitle>Busca por referencia</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Introduce una referencia correcta para firmar la tarea
                    </DialogContentText>
                    <TextField
                        label="Referencia"
                        value={referenceSearch}
                        fullWidth
                        inputProps={{ inputMode: 'numeric' }}
                        onChange={event => setRefeferenceSearch(event.target.value)}
                    />
                    <DialogActions>
                        <Button onClick={() => setOpenSearch(false)}>
                            Cancelar
                        </Button>
                        <Button color="primary" onClick={() => handleShowPDFByReference(1)}>
                            Firma 1
                        </Button>
                        <Button color="primary" onClick={() => handleShowPDFByReference(2)}>
                            Firma 2
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default TaskSignContainer